@if (showSplash) {
  <div class="app-splash-screen row align-items-center" [ngStyle]="{ left: windowWidth }">
    <div class="col m-0 p-0 text-center">
      <img src="assets/logos/TuPiscinero-logo-small.png" style="margin-bottom: 15px;">
      <br>
        <div class="progress-bar-wrapper">
          <div class="progress">
            <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" [style.width]="currentBarWidth + '%'"></div>
          </div>
        </div>
      </div>
    </div>
  }